export default abstract class ChallengeBaseService {}
